/**
 * Get the developer profile URL based on ID and studio slug
 */
export const getDeveloperProfileUrl = ({ id, studio_slug }: { id: string; studio_slug?: string | null }): string => {
  if (studio_slug) {
    return `/developer/${studio_slug}`;
  }
  return `/developer/${id}`;
};

/**
 * Get the display name for a developer, prioritizing studio_name over display_name
 */
export const getDeveloperDisplayName = (developer: {
  display_name: string;
  studio_name?: string | null;
}): string => {
  return developer.studio_name || developer.display_name;
};

/**
 * Get the first letter of the display name for avatars, prioritizing studio_name over display_name
 */
export const getDeveloperInitial = (developer: {
  display_name: string;
  studio_name?: string | null;
}): string => {
  const displayName = getDeveloperDisplayName(developer);
  return displayName.charAt(0).toUpperCase();
};